// Translations for 13Labs OÜ website
// Estonian (ET) and English (EN)

export const translations = {
  et: {
    // SEO Meta
    meta: {
      title: "13Labs OÜ - Tarkvara Arendus, AI Lahendused ja IT Konsultatsioon",
      description: "13Labs OÜ pakub tarkvara arendust, AI lahendusi ja IT konsultatsiooniteenuseid. Loome kohandatud ärirakendusi ja automaatika tööriistu Eesti ja EU ettevõtetele.",
      keywords: "tarkvara arendus, AI lahendused, IT konsultatsioon, kohandatud rakendused, automaatika, tehisintellekt, Eesti, Tallinn"
    },

    // Navigation
    nav: {
      home: "Avaleht",
      services: "Teenused",
      about: "Meist",
      contact: "Kontakt",
      terms: "Kasutustingimused",
      privacy: "Privaatsuspoliitika",
      cookies: "Küpsiste poliitika"
    },

    // Hero Section
    hero: {
      title: "Intelligentsed Tarkvaralahendused ja AI-põhised Süsteemid Ettevõtetele",
      subtitle: "Loome kohandatud digitaalseid süsteeme, automaatika tööriistu ja AI-põhiseid platvorme, mis muudavad tegevust ja kiirendavad kasvu.",
      cta: "Võta Ühendust"
    },

    // Expertise Section
    expertise: {
      title: "Meie Ekspertiis",
      subtitle: "Terviklikud lahendused kogu tehnoloogia spektris",
      items: [
        {
          id: 1,
          title: "AI Lahendused ja Automaatika",
          description: "Muudame teie tegevust intelligentse automaatika, generatiivse AI integratsiooni ja kohandatud AI assistentidega, mis töötavad 24/7.",
          icon: "brain"
        },
        {
          id: 2,
          title: "Kohandatud Tarkvara Arendus",
          description: "Täielik skaleeritavate veebi- ja mobiilirakenduste, taustasüsteemide ja sujuva kolmandate osapoolte integratsioonide arendus.",
          icon: "code"
        },
        {
          id: 3,
          title: "IT Konsultatsioon ja CTO-teenusena",
          description: "Strateegiline tehnoloogiline juhendamine, süsteemide arhitektuur ja fraktsionaalne CTO teenus teie digitaalse transformatsiooni juhtimiseks.",
          icon: "lightbulb"
        }
      ]
    },

    // Why Choose Us
    approach: {
      title: "Miks Valida 13Labs",
      subtitle: "Põhimõtted, mis toovad tulemusi",
      points: [
        {
          id: 1,
          title: "AI-esimene Metoodika",
          description: "Integreerime tipptasemel tehisintellekti igasse lahendusse, tagades teie konkurentsieelise."
        },
        {
          id: 2,
          title: "Puhas Inseneriastandard",
          description: "Tootmisvalmis kood, töökindel testimine ja dokumentatsioon, mis muudab hoolduse vaevavabaks."
        },
        {
          id: 3,
          title: "Skaleeritavad Arhitektuurid",
          description: "Süsteemid, mis on loodud kasvama koos teie äriga, alates MVP-st kuni ettevõtte tasemeni."
        },
        {
          id: 4,
          title: "Kiired Täitmistsüklid",
          description: "Agiilne tarnimisprotsess, mis viib teid turule kiiremini ilma kvaliteeti ohverdamata."
        },
        {
          id: 5,
          title: "Läbipaistev Suhtlus",
          description: "Regulaarsed uuendused, selged tegevuskavad ja otsene juurdepääs teie arendusmeeskonnale."
        },
        {
          id: 6,
          title: "Pikaajaline Tugi",
          description: "Oleme teie tehnoloogiapartner ka pärast käivitamist, tagades pideva optimeerimise ja arengu."
        }
      ]
    },

    // CTA Section
    ctaSection: {
      title: "Loome Koos Midagi Ainulaadset",
      subtitle: "Valmis muutma oma äri intelligentse tehnoloogiaga?",
      cta: "Alusta Vestlust"
    },

    // Services Page
    services: {
      title: "Meie Teenused",
      subtitle: "Terviklikud tehnoloogilised lahendused teie ärivajaduste jaoks",
      categories: [
        {
          id: 1,
          title: "AI Lahendused ja Automaatika",
          description: "Kasutage tehisintellekti võimsust tööprotsesside automatiseerimiseks, otsuste parandamiseks ja intelligentsete süsteemide loomiseks.",
          offerings: [
            {
              name: "AI Assistendid ja Vestlusrobotid",
              detail: "Kohandatud vestluslik AI, mis käsitleb klienditeenindust, sisemisi päringuid ja automatiseerib suhtlust."
            },
            {
              name: "Generatiivse AI Integratsioon",
              detail: "Sujuv GPT, Claude ja teiste LLM-ide integreerimine teie toodetesse ja tööprotsessidesse."
            },
            {
              name: "Automaatika Platvormid",
              detail: "Täielik protsesside automaatika, mis kõrvaldab korduvad ülesanded ja vähendab tegevuskulusid."
            },
            {
              name: "Andmetöötlus ja Analüütika",
              detail: "AI-põhised andmekonveierid, mis ekstraktivad teadmisi ja võimaldavad andmepõhist otsustamist."
            },
            {
              name: "Arvutinägemise Lahendused",
              detail: "Pildi- ja videoanalüüsi süsteemid kvaliteedikontrolli, turvalisuse ja sisu modereerimise jaoks."
            }
          ]
        },
        {
          id: 2,
          title: "Kohandatud Tarkvara Arendus",
          description: "Täistükli arendusteenused kontseptsioonist juurutamiseni, luues töökindlaid rakendusi, mis kasvavad koos teie äriga.",
          offerings: [
            {
              name: "Veebirakendused",
              detail: "Kaasaegsed, reageerivad veebirakendused, mis on loodud React, Next.js ja tipptasemel tehnoloogiatega."
            },
            {
              name: "Mobiilirakendused",
              detail: "Natiivsed ja platvormidevahelised mobiililahendused iOS-ile ja Androidile."
            },
            {
              name: "Taustasüsteemid ja API-d",
              detail: "Skaleeritavad serverarhitektuurid, RESTful API-d ja mikroteenused, mis on loodud FastAPI, Node.js-iga."
            },
            {
              name: "Süsteemi Integratsioonid",
              detail: "Ühendage oma tööriistad ja platvormid kohandatud integratsioonide ja vahevara lahendustega."
            },
            {
              name: "UI/UX Disain",
              detail: "Kasutajakeskne disain, mis ühendab esteetika ja funktsionaalsuse erakordse kasutajakogemuse loomiseks."
            },
            {
              name: "Andmebaasi Arhitektuur",
              detail: "Optimeeritud andmebaasi disain ja haldus PostgreSQL, MongoDB ja pilveteenuste jaoks."
            }
          ]
        },
        {
          id: 3,
          title: "IT Konsultatsioon ja CTO-teenusena",
          description: "Strateegiline tehnoloogiajuhtimine ja ekspertide juhendamine keerukate tehniliste otsuste tegemisel ja kasvu kiirendamisel.",
          offerings: [
            {
              name: "Tehniline Audit ja Hindamine",
              detail: "Põhjalik teie praeguste süsteemide ülevaade, kitsaskohtade ja optimeerimise võimaluste tuvastamine."
            },
            {
              name: "Süsteemiarhitektuuri Disain",
              detail: "Loome skaleeritavaid, turvalisi ja hallatavaid süsteemiarhitektuure, mis on kooskõlas äri eesmärkidega."
            },
            {
              name: "Digitaalse Transformatsiooni Strateegia",
              detail: "Tegevuskava pärandsüsteemide moderniseerimiseks ja uute tehnoloogiate tõhusaks kasutuselevõtuks."
            },
            {
              name: "Toote ja Tehnoloogia Planeerimine",
              detail: "Strateegiline juhendamine tehnoloogiapaki valiku, funktsioonide prioriseerimise ja arenduse tegevuskavade osas."
            },
            {
              name: "CTO-teenusena",
              detail: "Fraktsionaalne CTO teenus, pakkudes juhtimist, meeskonna juhtimist ja tehnilist suunamist."
            },
            {
              name: "Meeskonna Laiendamine",
              detail: "Eksperdid arendajad teie meeskonna suurendamiseks ja projekti tarnimise kiirendamiseks."
            }
          ]
        }
      ],
      cta: {
        title: "Valmis Alustama?",
        description: "Arutame, kuidas saame aidata muuta teie äri intelligentse tehnoloogiaga.",
        button: "Võta Ühendust"
      }
    },

    // About Page
    about: {
      title: "Meist",
      mission: {
        title: "Meie Missioon",
        content: "Loome intelligentseid ja tõhusaid digitaalseid lahendusi, mis võimaldavad ettevõtetel innoveerida, skaleerida ja õitseda AI-põhises maailmas. Meie fookus on käegakatsutava väärtuse loomine tipptasemel tehnoloogia ja inseneritöö tipptaseme kaudu."
      },
      principles: {
        title: "Meie Põhimõtted",
        items: [
          {
            title: "AI-esimene Innovatsioon",
            description: "Me ei kasuta lihtsalt AI-d – me oleme selle rakendamise teerajajad, püsides tehnoloogilise arengu eesotsas."
          },
          {
            title: "Minimalistlik Tipptase",
            description: "Elegantne lahendused ilma tarbetu keerukuseta. Puhas kood, intuitiivne liides, maksimaalne mõju."
          },
          {
            title: "Kiirus ja Agilsus",
            description: "Kiire iteratsioon ja juurutamine ilma kvaliteeti või turvalisust ohverdamata."
          },
          {
            title: "Skaleeritavus Disainis",
            description: "Iga süsteem, mida ehitame, on arhitektuurilt loodud kasvama sujuvalt startup'ist ettevõtte tasemeni."
          }
        ]
      },
      location: {
        title: "Kus Me Töötame",
        content: "Asudes Tallinnas, Eestis, tegutseme remote-first ettevõttena, tehes koostööd klientide ja partneritega üle Euroopa ja kaugemalgi. Meie hajutatud lähenemine võimaldab meil kasutada globaalset talenti, säilitades samas paindlikkuse ja tõhususe, mida meie kliendid hindavad."
      }
    },

    // Contact Page
    contact: {
      title: "Räägime",
      subtitle: "On sul projekt meeles? Tahaksime sellest kuulda.",
      form: {
        name: "Nimi",
        namePlaceholder: "Teie Nimi",
        email: "E-post",
        emailPlaceholder: "E-posti Aadress",
        company: "Ettevõte",
        companyPlaceholder: "Ettevõtte Nimi (valikuline)",
        message: "Sõnum",
        messagePlaceholder: "Rääkige meile oma projektist...",
        submit: "Saada Sõnum",
        sending: "Saadan...",
        required: "*"
      },
      info: "Vastame tavaliselt 24 tunni jooksul tööpäevadel."
    },

    // Footer
    footer: {
      tagline: "Ehitame tulevikku intelligentse tehnoloogiaga.",
      company: "Ettevõte",
      getInTouch: "Võta Ühendust",
      getInTouchText: "Valmis muutma oma äri intelligentse tehnoloogiaga?",
      contactUs: "Võta Ühendust →",
      copyright: "© 2025 13Labs OÜ. Kõik õigused kaitstud."
    },

    // Buttons
    buttons: {
      getStarted: "Alusta",
      learnMore: "Lisateave",
      readMore: "Loe Rohkem"
    }
  },

  en: {
    // SEO Meta
    meta: {
      title: "13Labs OÜ - Software Development, AI Solutions & IT Consulting",
      description: "13Labs OÜ provides software development, AI solutions, and IT consulting services. Creating custom applications and automation tools for businesses in Estonia and EU.",
      keywords: "software development, AI solutions, IT consulting, custom applications, automation, artificial intelligence, Estonia, Tallinn"
    },

    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
      terms: "Terms of Service",
      privacy: "Privacy Policy",
      cookies: "Cookie Policy"
    },

    // Hero Section
    hero: {
      title: "Intelligent Software & AI-Driven Solutions for Business",
      subtitle: "Building custom digital systems, automation tools, and AI-powered platforms that transform operations and accelerate growth.",
      cta: "Get in Touch"
    },

    // Expertise Section
    expertise: {
      title: "Our Expertise",
      subtitle: "Comprehensive solutions across the technology spectrum",
      items: [
        {
          id: 1,
          title: "AI Solutions & Automation",
          description: "Transform your operations with intelligent automation, generative AI integration, and custom AI assistants that work 24/7.",
          icon: "brain"
        },
        {
          id: 2,
          title: "Custom Software Development",
          description: "End-to-end development of scalable web and mobile applications, backend systems, and seamless third-party integrations.",
          icon: "code"
        },
        {
          id: 3,
          title: "IT Consulting & CTO-as-a-Service",
          description: "Strategic technology guidance, system architecture, and fractional CTO services to drive your digital transformation.",
          icon: "lightbulb"
        }
      ]
    },

    // Why Choose Us
    approach: {
      title: "Why Choose 13Labs",
      subtitle: "Built on principles that deliver results",
      points: [
        {
          id: 1,
          title: "AI-First Methodology",
          description: "We integrate cutting-edge AI into every solution, ensuring you stay ahead of the competition."
        },
        {
          id: 2,
          title: "Clean Engineering Standards",
          description: "Production-ready code, robust testing, and documentation that makes maintenance effortless."
        },
        {
          id: 3,
          title: "Scalable Architectures",
          description: "Systems designed to grow with your business, from MVP to enterprise scale."
        },
        {
          id: 4,
          title: "Fast Execution Cycles",
          description: "Agile delivery process that gets you to market faster without compromising quality."
        },
        {
          id: 5,
          title: "Transparent Communication",
          description: "Regular updates, clear roadmaps, and direct access to your development team."
        },
        {
          id: 6,
          title: "Long-Term Support",
          description: "We're your technology partner beyond launch, ensuring continuous optimization and evolution."
        }
      ]
    },

    // CTA Section
    ctaSection: {
      title: "Let's Build Something Together",
      subtitle: "Ready to transform your business with intelligent technology?",
      cta: "Start a Conversation"
    },

    // Services Page
    services: {
      title: "Our Services",
      subtitle: "Comprehensive technology solutions tailored to your business needs",
      categories: [
        {
          id: 1,
          title: "AI Solutions & Automation",
          description: "Harness the power of artificial intelligence to automate workflows, enhance decision-making, and create intelligent systems that work for you.",
          offerings: [
            {
              name: "AI Assistants & Chatbots",
              detail: "Custom conversational AI that handles customer support, internal queries, and automates communication."
            },
            {
              name: "Generative AI Integration",
              detail: "Seamlessly integrate GPT, Claude, and other LLMs into your products and workflows."
            },
            {
              name: "Automation Platforms",
              detail: "End-to-end process automation that eliminates repetitive tasks and reduces operational costs."
            },
            {
              name: "Data Processing & Analytics",
              detail: "AI-powered data pipelines that extract insights and enable data-driven decision making."
            },
            {
              name: "Computer Vision Solutions",
              detail: "Image and video analysis systems for quality control, security, and content moderation."
            }
          ]
        },
        {
          id: 2,
          title: "Custom Software Development",
          description: "Full-cycle development services from concept to deployment, building robust applications that scale with your business.",
          offerings: [
            {
              name: "Web Applications",
              detail: "Modern, responsive web apps built with React, Next.js, and cutting-edge technologies."
            },
            {
              name: "Mobile Applications",
              detail: "Native and cross-platform mobile solutions for iOS and Android."
            },
            {
              name: "Backend Systems & APIs",
              detail: "Scalable server architectures, RESTful APIs, and microservices built with FastAPI, Node.js, and more."
            },
            {
              name: "System Integrations",
              detail: "Connect your tools and platforms with custom integrations and middleware solutions."
            },
            {
              name: "UI/UX Design",
              detail: "User-centered design that combines aesthetics with functionality for exceptional user experiences."
            },
            {
              name: "Database Architecture",
              detail: "Optimized database design and management for PostgreSQL, MongoDB, and cloud solutions."
            }
          ]
        },
        {
          id: 3,
          title: "IT Consulting & CTO-as-a-Service",
          description: "Strategic technology leadership and expert guidance to navigate complex technical decisions and accelerate growth.",
          offerings: [
            {
              name: "Technical Audit & Assessment",
              detail: "Comprehensive review of your current systems, identifying bottlenecks and optimization opportunities."
            },
            {
              name: "System Architecture Design",
              detail: "Blueprint scalable, secure, and maintainable system architectures aligned with business goals."
            },
            {
              name: "Digital Transformation Strategy",
              detail: "Roadmap for modernizing legacy systems and adopting new technologies effectively."
            },
            {
              name: "Product & Technology Planning",
              detail: "Strategic guidance on tech stack selection, feature prioritization, and development roadmaps."
            },
            {
              name: "CTO-as-a-Service",
              detail: "Fractional CTO services providing leadership, team management, and technical direction."
            },
            {
              name: "Team Augmentation",
              detail: "Expert developers to scale your team and accelerate project delivery."
            }
          ]
        }
      ],
      cta: {
        title: "Ready to Get Started?",
        description: "Let's discuss how we can help transform your business with intelligent technology.",
        button: "Contact Us"
      }
    },

    // About Page
    about: {
      title: "About 13Labs",
      mission: {
        title: "Our Mission",
        content: "We create intelligent and efficient digital solutions that empower businesses to innovate, scale, and thrive in an AI-driven world. Our focus is on delivering tangible value through cutting-edge technology and engineering excellence."
      },
      principles: {
        title: "Our Principles",
        items: [
          {
            title: "AI-First Innovation",
            description: "We don't just use AI—we pioneer its application, staying at the forefront of technological advancement."
          },
          {
            title: "Minimalist Excellence",
            description: "Elegant solutions without unnecessary complexity. Clean code, intuitive interfaces, maximum impact."
          },
          {
            title: "Speed & Agility",
            description: "Rapid iteration and deployment without compromising quality or security."
          },
          {
            title: "Scalability by Design",
            description: "Every system we build is architected to grow seamlessly from startup to enterprise."
          }
        ]
      },
      location: {
        title: "Where We Work",
        content: "Based in Tallinn, Estonia, we operate as a remote-first company, collaborating with clients and partners across Europe and beyond. Our distributed approach allows us to tap into global talent while maintaining the agility and efficiency our clients value."
      }
    },

    // Contact Page
    contact: {
      title: "Let's Talk",
      subtitle: "Have a project in mind? We'd love to hear about it.",
      form: {
        name: "Name",
        namePlaceholder: "Your Name",
        email: "Email",
        emailPlaceholder: "Email Address",
        company: "Company",
        companyPlaceholder: "Company Name (Optional)",
        message: "Message",
        messagePlaceholder: "Tell us about your project...",
        submit: "Send Message",
        sending: "Sending...",
        required: "*"
      },
      info: "We typically respond within 24 hours during business days."
    },

    // Footer
    footer: {
      tagline: "Building the future with intelligent technology.",
      company: "Company",
      getInTouch: "Get in Touch",
      getInTouchText: "Ready to transform your business with intelligent technology?",
      contactUs: "Contact Us →",
      copyright: "© 2025 13Labs OÜ. All rights reserved."
    },

    // Buttons
    buttons: {
      getStarted: "Get Started",
      learnMore: "Learn More",
      readMore: "Read More"
    }
  }
};
